import { render, staticRenderFns } from "./FeedbackElementUpdate.vue?vue&type=template&id=89f5053c&"
import script from "./FeedbackElementUpdate.vue?vue&type=script&lang=js&"
export * from "./FeedbackElementUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports